export default "__FINAL_URL__CMbf_VUY__";